<template>
  <div>
    <v-container id="regular-tables" fluid tag="section">
      <v-simple-table :dark="$store.state.isDarkMode">
        <thead class="table-heading" v-if="!tableOptions.loading">
          <tr>
            <th v-for="(name, i) in tableOptions.tableHeaders" :key="i">
              {{ $t(name) }}
            </th>
          </tr>
        </thead>
        <div class="table__spinnerWrapper" v-if="tableOptions.loading">
          <app-spinner></app-spinner>
        </div>
        <v-fade-transition mode="out-in" :group="true" tag="tbody">
          <tr
            v-for="(item, idx) in tableOptions.tableData"
            :key="idx"
            v-show="!tableOptions.loading"
          >
            <td :key="index" v-for="(value, key, index) of castItems(item)">
              <span v-html="accessData(item, index)"></span>
            </td>
            <td class="d-flex justify-center" v-if="displaySettings">
              <slot name="editFeature" :row="item"></slot>
              <app-table-delete-modal
                v-if="enableDelete"
                :tableRecord="item"
                :serverRoute="serverRoute"
                @record-deleted="reFetchData"
              ></app-table-delete-modal>
            </td>
          </tr>
        </v-fade-transition>
      </v-simple-table>
      <div class="d-flex justify-end mt-5" v-if="!tableOptions.loading">
        <app-pagination
          :totalPages="tableOptions.tableMeta.total"
          :page="tableOptions.tableMeta.page"
          :perPage="getPerPage()"
          @PaginationValue="fetchNewPaginated($event)"
        ></app-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import spinner from "./spinner.vue";
import pagination from "./pagination.vue";
import tableDeleteModal from "./tableDeleteModal.vue";
//
export default {
  components: {
    appTableDeleteModal: tableDeleteModal,
    appSpinner: spinner,
    appPagination: pagination,
  },
  data() {
    return {
      deleteDialog: false,
    };
  },

  props: {
    serverRoute: String,
    enableDelete: {
      type: Boolean,
      default: true,
    },
    flaggedItems: {
      type: Array,
      default() {
        return [];
      },
    },
    displaySettings: {
      type: Boolean,
      default: true,
    },
    tableOptions: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  // computed: {
  //   ...mapGetters({
  //     tableOptions: "tablesStore/getTableOptions",
  //   }),
  // },
  methods: {
    getPerPage() {
      if (this.tableOptions.tableMeta.perPage) {
        return this.tableOptions.tableMeta.perPage;
      } else {
        return 10;
      }
    },
    castItems(item) {
      let copyItem = { ...item };
      this.flaggedItems.forEach((el) => {
        delete copyItem[el];
      });
      return copyItem;
    },
    accessData(row, index) {
      return this.fetchAttributes(
        row,
        this.tableOptions.accessTableData[index]
      );
    },
    fetchAttributes(row, nestedKey) {
      let value = row;
      for (let key in nestedKey) {
        if (value[nestedKey[key]]) {
          value = value[nestedKey[key]];
        } else {
          return;
        }
      }
      return this.$i18n.t(value.toLocaleString());
    },
    fetchNewPaginated(paginationValue) {
      this.$emit("re-fetch-paginated-data", paginationValue);
    },
    reFetchData() {
      this.$emit("re-fetch-data");
    },
  },
};
</script>

<style></style>
